import { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ClearIcon from '@mui/icons-material/Clear';
import { CardActionArea, Checkbox, FormControlLabel, Grid, IconButton } from '@mui/material';
import imagePlaceHolder from 'src/assets/no_image.png';


const FrontOptionsView = ({ view, product, handleChangeSelected, getVariation, type }) => {
  const noImage = product?.imageUrl;
  return (
    <>
      {view === "list" ?
        (<>

        </>
          // <Card sx={{ width: "100%", height: "170px", overflowY: "auto", marginRight: "15px", marginBottom: "15px" }}>

          //   <CardContent>
          //     <Grid className='flex justify-between'>
          //       <Grid>
          //         <Typography gutterBottom fontSize={"medium"} component="div">
          //           {type === 'ranges' && <FormControlLabel
          //             control={<Checkbox />}
          //             // value={checked} 
          //             onChange={(e) => handleChangeSelected(e.target.checked, product.id, product)}
          //           />}
          //           {product.productId}
          //         </Typography>
          //       </Grid>
          //       <Grid>
          //         {type === 'ranges' ?
          //           <IconButton onClick={() => getVariation(product.id)}><ModeEditIcon /></IconButton>
          //           :
          //           <IconButton onClick={(e) => handleChangeSelected(e.target.checked, product.id, product)}><ClearIcon /></IconButton>
          //         }
          //       </Grid>
          //     </Grid>
          //     <Grid container spacing={2}>
          //       <Grid item xs={4}>
          //         {noImage === null ? <img
          //           src={imagePlaceHolder}
          //           style={{ objectFit: 'cover', height: "80px", width: "280px", borderRadius: "5px" }}
          //         />
          //           :
          //           <img
          //             src={product.imageUrl}
          //             onError={(e) => { e.currentTarget.src = imagePlaceHolder }}
          //             style={{ objectFit: 'cover', height: "80px", width: "280px", borderRadius: "5px" }}
          //           />
          //         }
          //       </Grid>

          //       <Grid item xs={8}>
          //         <Typography variant="body2" color="text.secondary">
          //           <p>Name - {product.productName}</p>
          //           <p>Product - {product._class}</p>
          //         </Typography>
          //       </Grid>
          //     </Grid>

          //   </CardContent>

          // </Card>
        ) :
        (
          <Card sx={{ width: 165, height: 210, overflowY: "auto", marginRight: "15px", marginBottom: "15px" }}>

            <CardContent>
              <Grid className='flex justify-between'>
                <Grid className='flex items-center'>

                    <FormControlLabel
                    control={<Checkbox />}
                    onChange={(e) => handleChangeSelected(e.target.checked, product.id, product)}
                    label={product.productId}
                  />
                  

                </Grid>
                <Grid>
                  {type === 'ranges' &&
                    <IconButton onClick={() => getVariation(product.id)}><ModeEditIcon /></IconButton>
                    // :
                    // <IconButton onClick={(e) => handleChangeSelected(e.target.checked, product.id, product)}><ClearIcon /></IconButton>
                  }
                </Grid>
              </Grid>
              <Grid>
                <Grid>
                  <Typography variant="body2" color="text.secondary" fontSize={"small"}>
                    {product.productName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontSize={"small"}>
                    {product._class}
                  </Typography>

                </Grid>
              </Grid>

            </CardContent>
            {noImage === null ?

              <img
                alt='No image'
                src={imagePlaceHolder}
                style={{ objectFit: "cover", height: "40%", width: "100%", borderRadius: "5px" }}
              />
              :
              <img
                alt='image'
                src={product.imageUrl}
                onError={(e) => { e.currentTarget.src = imagePlaceHolder }}
                style={{ objectFit: "cover", height: "40%", width: "100%", borderRadius: "5px" }}
              />

            }
          </Card>
        )}

    </>
  )
}

export default FrontOptionsView